
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter, withRouter } from 'next/router';

function DownloadApp(props) {
	const [state, setState] = useState([]);
	
	return (


	<div class="download-app-page container">
		<div class="inner">
			<img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/Community-footer-r1.webp"></img>
			<h2 className="headingF headingF-sm">Become part of the BAYAN community</h2>
			<p>Download our app on iOS or Google Play</p>
			<ul>
				<li><img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/screen1@2x.webp"></img></li>
				<li><img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/screen2@2x.webp"></img></li>
				<li><img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/screen3@2x.webp"></img></li>
				<li><img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/screen4@2x.webp"></img></li>
				<li><img src="https://bayan.s3-us-west-2.amazonaws.com/static-content/screen5@2x.webp"></img></li>
			</ul>
		</div>
		<div class="download-link">
			<a href="https://play.google.com/store/apps/details?id=com.bayanonline"><img width="200" src="https://bayan.s3-us-west-2.amazonaws.com/static-content/google-play-badge.png"></img></a>
			<a href="https://apps.apple.com/us/app/bayan-online/id1531952970"><img width="200" src="https://bayan.s3-us-west-2.amazonaws.com/static-content/apple-app-store-badge.png"></img></a>
		</div>
		{/* <p class="note-text">Or enter your phone number below to receive a link to download the Bayan App!</p>
		<form>
			<div class="enter-phone">
				<div class="field-rd">
					<label>Enter Phone</label>
					<input type="text" name=""></input>
				</div>
				<a href="#">Send an SMS</a>
			</div>
		</form> */}
	</div>
	);
}

export default withRouter(DownloadApp);
